export default __webpack_public_path__ + "static/media/founders.8790ba32.jpg";